import { render, staticRenderFns } from "./TourBundle.vue?vue&type=template&id=97a645ce&"
import script from "./TourBundle.vue?vue&type=script&lang=js&"
export * from "./TourBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports